// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"563":"ecddf54b","708":"4e44f34b"}[chunkId] + ".chunk.css";
};